/**
 * Franchise Homepage Page Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

/* global jQuery */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {};


    exports.init = function() {
        // Initialize... nothing yet.
        
    };

    return exports;

})(Otto, jQuery);